// Typesets server-rendered maths (`.mq-tex[data-tex]`) without putting KaTeX
// (~277KB) in front of every page.
//
// hydrate.js imports renderTex, which imports katex, so importing hydrate
// statically put KaTeX in the application pack's initial download for the
// home page and the Devise pages too. This loads it only when `root` actually
// contains a maths node. Until it arrives the span shows its own delimited
// source (`$x^2$`), which is the fallback hydrate.js was designed around.
//
// The React surfaces that render maths (the exam room, the workbenches) import
// renderTex themselves, inside the lazily loaded component registry, so they
// are unaffected by this module.
export default function typesetMath(root = document) {
  if (!root.querySelector(".mq-tex[data-tex]")) return Promise.resolve();

  return import(
    /* webpackChunkName: "math-typeset" */ "./components/mocks/math/hydrate"
  ).then(({ default: hydrateMathNodes }) => hydrateMathNodes(root));
}
